import { IsoLocale } from "@izettle/constants"

const supportedLocales = Object.values(IsoLocale)

export const getLocale = (
  userLocales: readonly string[],
  allowedLocales: IsoLocale[] = supportedLocales,
): IsoLocale | null => {
  // We need to hard-code the locale to ensure consistency in stories and their snapshots.
  // TODO: Create a storybook addon that sets this for us, and allows changing locale
  if (process.env.IS_STORYBOOK) {
    return IsoLocale.enGB
  }

  const usersValidLocale = userLocales.find((locale) =>
    allowedLocales.includes(locale as any),
  )

  if (usersValidLocale != null) {
    return usersValidLocale as IsoLocale
  }

  const languagesWithoutCountries = userLocales.map((locale) =>
    locale.includes("-") ? locale.slice(0, locale.indexOf("-")) : locale,
  )
  const firstBestLocale = allowedLocales.find((locale) =>
    locale.startsWith(languagesWithoutCountries as any),
  )

  return firstBestLocale ?? null
}
